module.exports = __webpack_public_path__ + "static/media/a_05.9788cbff.jpg";